import React from "react";

export default function SettingsSaveBar({ dirty, saving, onReview, onSave }) {
  return (
    <div
      className={`pointer-events-none fixed inset-x-0 bottom-16 md:bottom-0 z-30 transition-transform duration-200 ${
        dirty ? "translate-y-0" : "translate-y-full"
      }`}
    >
      <div className="pointer-events-auto mx-auto mb-6 max-w-2xl px-4">
        <div className="rounded-2xl border border-border bg-surface-elevated shadow-2xl p-3 flex items-center justify-between">
          <div className="text-sm text-text-secondary">
            You have unsaved changes
          </div>
          <div className="flex items-center gap-2">
            <button
              type="button"
              className="px-3 py-1.5 rounded-md border border-border-strong text-sm hover:bg-surface"
              onClick={onReview}
            >
              Review
            </button>
            <button
              type="button"
              className="px-4 py-1.5 rounded-md bg-primary text-text-inverse text-sm hover:bg-primary disabled:opacity-60"
              disabled={saving}
              onClick={onSave}
            >
              {saving ? "Saving…" : "Save changes"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
